import { useAppState } from "@/contexts/app/app.provider";
import { useEffect, useState } from "react";

export function useDeviceViewPort() {
  const { isMobile: mobile } = useAppState();

  const [isMobile, setIsMobile] = useState(mobile);

  useEffect(() => {
    if (window.innerWidth < 700) setIsMobile(true);
    else setIsMobile(false);
  }, []);

  useEffect(() => {
    function ls(event) {
      if (window.innerWidth < 700) setIsMobile(true);
      else setIsMobile(false);
    }

    window.addEventListener("resize", ls);

    return () => window.removeEventListener("resize", ls);
  }, []);

  return [isMobile];
}
